import { router } from 'expo-router';
import * as React from 'react';
import { Platform } from 'react-native';
import {
    BodyLargeRegular,
    CheckIcon,
    H5Emphasized,
    Icon,
    isWeb,
    View,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

const Approved = () => {
    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.05,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <YStack
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={20}
                    borderRadius={20}
                    backgroundColor="$green900"
                    marginTop={30}
                    marginBottom={30}
                    style={{ ...shadowStyle }}
                >
                    <Icon icon={CheckIcon} color="$white" size={40} />
                </View>
                <H5Emphasized textAlign="center" marginBottom={14}>
                    Success!
                </H5Emphasized>
                <BodyLargeRegular textAlign="center" color="$gray1100">
                    We&apos;ve confirmed your identity. Now let&apos;s customize
                    your account.
                </BodyLargeRegular>
            </View>
            <KycButton
                onPress={() => {
                    router.replace({
                        pathname: '/banking/create-edit-space',
                        params: { fromKyc: 'true' },
                    });
                }}
                text="Continue"
                hideSecureText
            />
        </YStack>
    );
};

export default Approved;
